import { useTranslation } from '../i18n/LanguageContext.jsx';
import TimelineImage from '../components/TimelineImage.jsx';
import AgentDescription from '../components/AgentDescription.jsx';
import ChatKitPanel from '../components/ChatKitPanel.jsx';
// Legacy ChatPanel kept as fallback:
// import ChatPanel from '../components/ChatPanel.jsx';
import './InterviewPage.css';

/**
 * InterviewPage — main layout for the interview agent.
 *
 * 3-section layout:
 * 1. TimelineImage — Peter's professional timeline graphic
 * 2. AgentDescription — bilingual description of the AI assistant
 * 3. ChatKitPanel — interactive chat via OpenAI ChatKit
 */
function InterviewPage() {
  const { t } = useTranslation();

  return (
    <main className="interview-page" aria-labelledby="interview-title">
      <h1 id="interview-title" className="interview-page__title">
        {t('interview.pageTitle')}
      </h1>
      <TimelineImage />
      <AgentDescription />
      <ChatKitPanel />
    </main>
  );
}

export default InterviewPage;
